/*
    模块组件
    ChenYN

    说明
    图片处理模块，会根据图片上传是一张还是大于一张去渲染页面

    版本
    1.0

    传参：
        images Array : 图片数组
        del Boolean : 非必填 是否可以删除 并且显示六张图 ，默认只有三张图
        delFun Function : 非必填 删除事件 返回一个下标
        load Function : 非必填 图片加载完成
    依赖
    /style/2019/h5/css/common.css
    vue.js
    vant

    案例
    <ImageHandle :images="data" />
*/

<template>
    <div class="img_wrapper" v-if="images && images.length > 0">
        <div class="banner_box" v-if="images.length < 2">
            <div class="img_box" :class="{ big_img: images[0].h > images[0].w }" >
                <img v-if="images[0].url" :src="images[0].url" @click.stop="preview(0)" @load="imageLoad" />
                <Icon v-if="del" class="del_icon" name="cross" @click="delFn(0)" />
            </div>
        </div>

        <div v-else class="banner_box_nine">
            <div class="img_box" :class="{ big_img: v.h > v.w }" v-for="(v, i) in del ? images :images.slice(0, 3)" :key="i" >
                <img v-if="v.url" :src="v.url" @click.stop="preview(i)" @load="imageLoad" />
                <Icon v-if="del" class="del_icon" name="cross" @click="delFn(i)" />
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { Image as VanImage, ImagePreview, Icon } from 'vant';
import { defineComponent, reactive, toRefs, onBeforeMount, onMounted, watch } from 'vue';

export default defineComponent({
    name: 'ImageHandle',
    props: {
        images: {
            type: [Array, Object],
            default: []
        },
        del: {
            type: Boolean,
            default: false
        },
        delFun: {
            type: Function,
        },
        load: {
            type: Function,
        }
    },
    components: { ImagePreview, VanImage, Icon },
    setup(props) {
        const state = reactive({
            images: [{
                url:'',
                w:'',
                h:''
            }]
        });


        watch(props, () => {
            imgWH();
        })

        onBeforeMount(() => {
            imgWH();
        })

        //处理图片宽高，去决定显示
        const imgWH = async () => {
            let arr = props.images;

            let lin = [];

            for(let i in arr){
                
                try{
                    let res = await checkImgWidth(arr[i])
                    lin.push({
                        url: arr[i],
                        w: res.width,
                        h: res.height
                    })

                }catch(err){
                    console.info(err)
                }
            }

            state.images = lin

        }

        //同步获取到图片宽高，因为onload是异步的； 缺点:会造成堵塞
        const checkImgWidth = (fileUrl) => {
            return new Promise((resolve, reject) => {
                let img = new Image();
                let res = {}

                
                img.src = fileUrl;

                img.onload = function () {
                    res = {
                        width: this.width,
                        height: this.height
                    }
                    resolve(res)
                }
            })
        }

        const preview = (idx) => {
            ImagePreview({
                images: props.images,
                startPosition: idx,
                closeable: true,
            });
        }

        const delFn = (index) => {
            if(props.delFun){
                props.delFun(index)
            }
        }

        const imageLoad = () => {
            if(props.load){
                props.load()
            }
        };
        

        return {
            ...toRefs(state),
            preview,
            delFn,
            imageLoad
        };
    },
});
</script>

<style lang="less" scoped>
@import url("./ImageHandle.less");
</style>